import {PerspectiveCamera} from "three";

export default class Camera extends PerspectiveCamera
{
    constructor(aspect, position) {
        super( 70, aspect, 0.01, 2000 );
        this.position.set( 0, 1, 25 );

        if ( position ) {
            this.lookAt( position );
        }
    }
}